export enum ValidationAction {

    ALLOW       = 1,
    WARNING     = 2,
    DENY        = 3,

}

export enum ValidationTrigger {

    TASK_CLOSE                  = 1,
    TASK_SCHEDULE_DATE_UPDATE   = 2,
    TASK_START_END_DATE_UPDATE  = 3,
    TASK_ON_OPEN                = 4


}
export enum ValidationCondition {

    HAS_OPEN_SUBTASKS                           = 1,
    HAS_OPEN_DEPENDENCY                         = 2,

    TASK_SCHEDULE_DATE_BEFORE_START_DATE        = 3,
    TASK_SCHEDULE_DATE_AFTER_END_DATE           = 4,
    TASK_SCHEDULE_DATE_AFTER_DEADLINE           = 5,

    TASK_DEPENDENCY_START_END_DATE_CONFLICTS    = 6,
    TASK_SUBTASK_START_END_DATE_CONFLICTS       = 7,

    PROJECT_CLOSED                              = 8


}

